interface RestaurantListErrorProps {
  message?: string;
}

export const RestaurantListError = ({ 
  message = "We're having trouble loading the restaurants. Please try again later." 
}: RestaurantListErrorProps) => {
  return (
    <div className="min-h-[50vh] bg-accent/50 rounded-lg flex flex-col items-center justify-center text-destructive p-8 animate-in fade-in-50">
      <h3 className="text-xl font-semibold mb-2">Error</h3>
      <p className="text-center max-w-md">{message}</p>
    </div>
  );
};